import isBrowser from 'utility/isBrowser'

let host = isBrowser && window.location.hostname
let parts = host && host.split('.')

export const origin = isBrowser && window.location && window.location.origin
export const subdomain = parts?.length > 2 ? parts?.[0] : null
